import { IntegType } from '@repo/api-gw-sdk';
import type { StaticImageData } from 'next/image';

import AmazonEMR from '../../../public/statics/images/integrations/Amazon EMR.png';
import AmazonRedshift from '../../../public/statics/images/integrations/Amazon Redshift.png';
import BigQuery from '../../../public/statics/images/integrations/BigQuery.png';
import Databricks from '../../../public/statics/images/integrations/Databricks.png';
import MicrosoftFabric from '../../../public/statics/images/integrations/Microsoft fabric.png';
import Snowflake from '../../../public/statics/images/integrations/Snowflake.png';
import UnknownLogo from '../../../public/statics/images/providers/unknown.png';

export const enum IntegrationVendor {
  UNKNOWN = 'Unknown',
  MICROSOFT_FABRIC = 'MicrosoftFabric',
  BIGQUERY = 'BigQuery',
  SNOWFLAKE = 'Snowflake',
  DATABRICKS = 'Databricks',
  AMAZON_EMR = 'AmazonEMR',
  AMAZON_REDSHIFT = 'AmazonRedshift',
}

export const IntegrationVendorDetails: Record<
  IntegrationVendor,
  { displayName: string; logo: StaticImageData }
> = {
  [IntegrationVendor.UNKNOWN]: {
    displayName: 'Unknown',
    logo: UnknownLogo,
  },
  [IntegrationVendor.MICROSOFT_FABRIC]: {
    displayName: 'Microsoft Fabric',
    logo: MicrosoftFabric,
  },
  [IntegrationVendor.BIGQUERY]: {
    displayName: 'BigQuery',
    logo: BigQuery,
  },
  [IntegrationVendor.SNOWFLAKE]: {
    displayName: 'Snowflake',
    logo: Snowflake,
  },
  [IntegrationVendor.DATABRICKS]: {
    displayName: 'Databricks',
    logo: Databricks,
  },
  [IntegrationVendor.AMAZON_EMR]: {
    displayName: 'Amazon EMR',
    logo: AmazonEMR,
  },
  [IntegrationVendor.AMAZON_REDSHIFT]: {
    displayName: 'Amazon Redshift',
    logo: AmazonRedshift,
  },
};

export const integTypeToVendorMap: Partial<
  Record<IntegType, IntegrationVendor>
> = {
  [IntegType.INTEGRATION_TYPE_BIGQUERY]: IntegrationVendor.BIGQUERY,
  [IntegType.INTEGRATION_TYPE_SNOWFLAKE]: IntegrationVendor.SNOWFLAKE,
  [IntegType.INTEGRATION_TYPE_DATABRICKS]: IntegrationVendor.DATABRICKS,
  [IntegType.INTEGRATION_TYPE_MICROSOFT_FABRIC]:
    IntegrationVendor.MICROSOFT_FABRIC,
  [IntegType.INTEGRATION_TYPE_REDSHIFT]: IntegrationVendor.AMAZON_REDSHIFT,
  [IntegType.INTEGRATION_TYPE_UNSPECIFIED]: IntegrationVendor.UNKNOWN,
};
